import styled from "styled-components"

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100svh;
`

export const Main = styled.div<{ $justifyCenter: boolean }>`
  display: flex;
  justify-content: ${({ $justifyCenter }) =>
    $justifyCenter ? "center" : "unset"};
  gap: 24px;
  padding: 0 0 64px 0;

  @media (max-width: ${({ theme }) => theme.bp.medium}px) {
    flex-direction: column;
  }
`

export const Block = styled.div<{ $k: number; $flat?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  box-shadow: 0 2px 4px 4px rgba(0, 0, 0, 0.1);
  padding: 24px;
  border-radius: 12px;

  ${({ $flat }) =>
    $flat &&
    `
    box-shadow: none;
    border: 1px solid #e5e7eb;
    border-radius: 20px;
    padding: 32px 20px 28px;
  `}

  opacity: 0;
  ${({ $k, theme }) =>
    theme.animations.types.fade +
    theme.animations.durations.main +
    theme.animations.delays.main($k)}
`

export const BlockTitle = styled.span<{ $k: number }>`
  font-size: 24px;
  font-weight: bold;
  color: #000;
  text-align: center;
  display: block;

  opacity: 0;
  ${({ $k, theme }) =>
    theme.animations.types.fadeTop +
    theme.animations.durations.main +
    theme.animations.delays.main($k)}
`

export const Feedback = styled.div<{ $k: number }>`
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 auto;

  font-size: 32px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.green.main};

  svg {
    width: 32px;
    min-width: 32px;
    height: 32px;
    min-height: 32px;
  }

  opacity: 0;
  ${({ $k, theme }) =>
    theme.animations.types.fadeTop +
    theme.animations.durations.main +
    theme.animations.delays.main($k)}

  @media (min-width: ${({ theme }) => theme.bp.medium}px) {
    gap: 12px;
  }
`

export const FeedbackIntructions = styled.div<{ $k: number }>`
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 auto;

  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black.secondary};

  svg {
    width: 32px;
    height: 32px;
  }

  opacity: 0;
  ${({ $k, theme }) =>
    theme.animations.types.fadeTop +
    theme.animations.durations.main +
    theme.animations.delays.main($k)}
`

export const Button = styled.button<{
  $outlined?: boolean
  $content?: boolean
}>`
  outline: none;
  background-color: ${({ $outlined, theme }) =>
    !$outlined ? theme.colors.blue.main : "transparent"};
  border: ${({ $outlined, theme }) =>
    $outlined ? `1px solid ${theme.colors.blue.main}` : "none"};
  cursor: pointer;
  padding: 0.6rem 1.4rem;
  border-radius: 4px;
  color: ${({ $outlined, theme }) =>
    $outlined ? theme.colors.blue.main : theme.colors.white.main};
  font-size: ${({ $outlined }) => ($outlined ? 16 : 14)}px;
  text-align: center;
  width: ${({ $content }) => ($content ? "fit-content" : "100%")};
  transition: box-shadow 0.3s, background-color 0.3s, color 0.3s;
  margin: ${({ $content }) => ($content ? "auto" : "unset")};

  &:hover,
  &:active {
    ${({ $outlined, theme }) =>
      !$outlined
        ? "box-shadow: 0 2px 8px 2px rgba(0, 0, 0, 0.24);"
        : `background-color: ${theme.colors.blue.main}; color: white;`}
  }
`

export const Icons = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;

  div {
    background: none;
    border: none;
    outline: none;
    padding: 4px;
    border-radius: 4px;
    transition: background-color 0.3s;
    cursor: pointer;
    width: fit-content;
    min-width: 42px;
    min-height: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    color: ${({ theme }) => theme.colors.blue.main};

    svg {
      width: 36px;
      height: 36px;
    }

    span {
      font-size: 14px;
      text-align: center;
    }

    &:hover {
      background-color: #eee;
    }

    @media (max-width: ${({ theme }) => theme.bp.medium}px) {
      &.seeTickets {
        display: none;
      }

      &:hover {
        background-color: transparent;
      }
    }
  }
`

export const PayedArea = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`

export const LoadingArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 24px 0;
`

export const ErrorWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;

  h2 {
    font-size: 24px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.black.secondary};
  }

  p {
    font-size: 16px;
    color: #666;
    max-width: 320px;
  }
`

export const ErrorButtons = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  max-width: 400px;
`
